export const noReturn =
  <T, R>(fn: (event: T) => R) =>
  (event: T) =>
    void fn(event)
